import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import ScrollToTop from "@/components/layout/ScrollToTop";
import { Layout } from "@/components/layout/Layout";
import { AuthProvider } from "@/context/AuthContext";
import { CookieConsent } from "@/components/CookieConsent";
import { trackPageView } from "@/lib/analytics";

import Home from "@/pages/Home";
import BusinessLine from "@/pages/BusinessLine";
import ChiSiamo from "@/pages/ChiSiamo";
import CasiStudio from "@/pages/CasiStudio";
import Investitori from "@/pages/Investitori";
import Proprietari from "@/pages/Proprietari";
import Contatti from "@/pages/Contatti";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Privacy from "@/pages/Privacy";
import Cookie from "@/pages/Cookie";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import BackOffice from "@/pages/BackOffice";

function Site({ children }) {
  return <Layout>{children}</Layout>;
}

function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <PageTracker />
          <SmoothScroll>
            <Routes>
              <Route path="/" element={<Site><Home /></Site>} />
              <Route path="/linee/:slug" element={<Site><BusinessLine /></Site>} />
              <Route path="/chi-siamo" element={<Site><ChiSiamo /></Site>} />
              <Route path="/casi-studio" element={<Site><CasiStudio /></Site>} />
              <Route path="/investitori" element={<Site><Investitori /></Site>} />
              <Route path="/proprietari" element={<Site><Proprietari /></Site>} />
              <Route path="/contatti" element={<Site><Contatti /></Site>} />
              <Route path="/blog" element={<Site><Blog /></Site>} />
              <Route path="/blog/:slug" element={<Site><BlogPost /></Site>} />
              <Route path="/privacy" element={<Site><Privacy /></Site>} />
              <Route path="/cookie" element={<Site><Cookie /></Site>} />
              <Route path="/login" element={<Login />} />
              <Route path="/riservata" element={<Dashboard />} />
              <Route path="/back-office" element={<BackOffice />} />
            </Routes>
            <CookieConsent />
          </SmoothScroll>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
